import React from 'react';
import { ClockIcon, PackageCheckIcon, RouteIcon, WrenchIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
const ICONS = {
  clock: ClockIcon,
  wrench: WrenchIcon,
  route: RouteIcon,
  package: PackageCheckIcon
};
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-brand-navy" data-id="element-16" data-mp="3no02zobujwt6">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-17" data-mp="38rist0fe8o87">
        <h2 id="beneficios" className="font-display text-base font-extrabold leading-tight text-white sm:text-xl" data-id="element-18" data-mp="38udawlaxpwyg">
          ¿Qué puede cambiar cuando empiezas?
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-[0.8rem] leading-snug text-white/80" data-id="element-19" data-mp="2ztoujjy2jkie">
          Tener material organizado puede transformar la forma de preparar tus
          clases.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-20" data-mp="xy4uxqp86gga">
          {benefits.map((benefit, i) => {
          const Icon = ICONS[benefit.icon];
          return <Reveal key={benefit.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-lg bg-brand-surface p-2.5 text-left" data-id="element-21" data-mp="2bdmhd75z7n3o" data-mpi={i}>
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-brand-green" data-id="element-22" data-mp="2l6tk0k9c0p02">
                  <Icon size={15} className="text-white" data-id="element-23" data-mp="1sg1qxvnkcggy" />
                </span>
                <div data-id="element-24" data-mp="1si4qb6alvlyc">
                  <h3 className="font-display text-[0.8rem] font-extrabold uppercase leading-tight text-brand-yellow" data-id="element-25" data-mp="1oezq5adzzwcv">
                    {benefit.title}
                  </h3>
                  <p className="mt-0.5 text-[0.76rem] leading-snug text-white/80" data-id="element-26" data-mp="22c4th2mbuh4f">
                    {benefit.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}